import { getRenderElement, setDefaults } from '@udecode/slate-plugins';
import { DEFAULTS_BBK_EXPRESSION } from './defaults';

export const renderElementBbkExpression = (options?: unknown) => {
  const { bbkExpression } = setDefaults(options, DEFAULTS_BBK_EXPRESSION);

  return getRenderElement(bbkExpression);
};
